import { axios } from '@/utils/request'

const api = {
  areaTreeData: '/adminapi/utils/areatree',
  areaListData: '/adminapi/utils/arealist',
  areaHashData: '/adminapi/utils/areahash',
  areaCountData: '/adminapi/utils/areaCount',
  getCityName: '/api/utils/getCityName',
}

export default api

export function getAreaTree(parameter) {
  return axios({
    url: api.areaTreeData,
    method: 'get',
    params: parameter
  })
}
export function getAreaList(parameter) {
  return axios({
    url: api.areaListData,
    method: 'get',
    params: parameter
  })
}

export function getAreaHash(parameter) {
  return axios({
    url: api.areaHashData,
    method: 'get',
    params: parameter
  })
}

export function getAreaCount(parameter) {
  return axios({
    url: api.areaCountData,
    method: 'get',
    params: parameter
  })
}


export function doUrlTask(parameter) {
  return axios({
    url: parameter.url,
    method: 'get',
    params: {}
  })
}

export function getCityName(parameter) {
  return axios({
    url: api.getCityName,
    method: 'get',
    params: parameter
  })
}